import {
  IconChatFilled,
  IconEmailFilled,
  IconPhoneFilled,
  IconQuestionMarkFilled,
} from '@iwoca/icons';
import { Modal } from '@iwoca/orion';

export const HelpModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  return (
    <Modal closeIcon isOpen={isOpen} onClose={onClose}>
      <div className="grid gap-l">
        <h1 className="text-center text-2xl font-med">Need help?</h1>
        <div className="grid w-full grid-cols-2 text-m xs:grid-cols-1 xs:gap-l">
          <div className="flex justify-center gap-s">
            <IconPhoneFilled className="h-[20px] w-[20px] fill-core-65" />
            <div>
              Call us at{' '}
              <a
                href="tel:+44-0203-778-0549"
                className="text-primary-40 underline"
              >
                0203 778 0549
              </a>
            </div>
          </div>
          <div className="flex justify-center gap-s">
            <IconChatFilled className="h-[20px] w-[20px] fill-core-65" />
            <div className="flex gap-xs">
              You can also
              <button
                onClick={onClose}
                className="ChatSupportButton !m-0 cursor-pointer border-none bg-transparent !p-0 !text-m text-primary-40 underline"
              >
                chat to us!
              </button>
            </div>
          </div>
        </div>
        <div className="mt-m text-center">
          Monday to Friday 9am &ndash; 6pm
          <br />
          <span className="text-s font-reg">(excluding bank holidays)</span>
        </div>

        <hr className="w-full border-[1px] border-structure-80" />

        <div className="grid grid-cols-[20px_auto] gap-s">
          <IconEmailFilled className="h-[20px] w-[20px] shrink-0 fill-core-65" />
          <div>
            Email at{' '}
            <a
              href="mailto:pay@iwoca.co.uk"
              className="text-primary-40 underline"
            >
              pay@iwoca.co.uk
            </a>
          </div>
          <IconQuestionMarkFilled className="h-[20px] w-[20px] shrink-0 fill-core-65" />
          <div>
            Find answers to common questions in our{' '}
            <a
              href="/faq/"
              target="_blank"
              className="text-primary-40 underline"
            >
              FAQ
            </a>
          </div>
        </div>
      </div>
    </Modal>
  );
};
